// client/src/locales/nl`

const nl = {
  translation: {
    form: {
      form_submit: 'Formulier indienen',
      make_a_choice: 'Maak een keuze',
    },
    general: {
      readMore: 'Lees meer',
      loading: 'Laden',
      close: 'Sluit',
    },
    blocks: {
      imageContainer: {
        error: 'Fout bij laden afbeelding'
      },
      mapBlock: {
        visitWebsite: 'Bekijk website',
        map: 'Kaart',
        list: 'Lijst',
      },
      milkPricesTableBlock: {
        labels: {
          year: 'Jaar',
          month: 'Maand',
          guaranteed_price: 'Gegarandeerde prijs',
          average_price: 'Gemiddelde prijs',
          protein: 'Eiwit',
          fat: 'Vet',
          lactose: 'Lactose',
        },
        months: {
          1: 'Januari',
          2: 'Februari',
          3: 'Maart',
          4: 'April',
          5: 'Mei',
          6: 'Juni',
          7: 'Juli',
          8: 'Augustus',
          9: 'September',
          10: 'Oktober',
          11: 'November',
          12: 'December',
        },
      },
    },
    searchbar: {
      label: 'Waar ben je naar op zoek?',
      placeholder: 'bijvoorbeeld: melk prijzen',
    },
    header: {
      language: 'Taal',
    },
    regionSwitch: {
      title: "FrieslandCampina, uw wereldwijde zuivelpartner",
      description: "Wij zijn een wereldwijde zuivelcoöperatie, actief in meer dan 50 landen",
      language: "Nederland"
    },
    footer: {
      links: {
        privacy: 'Privacy',
        terms_conditions: 'Algemene voorwaarden',
      },
      follow_us: 'Volg ons',
    },
    404: {
      title: 'Sorry, we kunnen deze pagina niet vinden',
      description:
        '<p>De pagina bestaat niet (meer) of is misschien verhuisd. Gebruik de zoekmachine om de informatie te vinden die je zoekt.</p>',
      link: '/',
      homepage: 'Naar homepage',
    },
    cookiebar: {
      title: 'Welkom!',
      description:
        'Waarschijnlijk heeft u al ervaring met bedrijven die op uw computer, tablet of telefoon cookies plaatsen. Friesland Campina maakt gebruik van cookies en u kunt kiezen uit onderstaande opties:',
      accept: 'Akkoord',
      complete: {
        title: 'Complete cookies',
        description:
          "Met behulp van deze cookies verbeteren we de website, maken we een koppeling met social media, kunt u video's bekijken en een adviseur zoeken.",
      },
      limited: {
        title: 'Beperkte cookies',
        description:
          "Met deze cookies kunt u een adviseur zoeken, video's bekijken en kunnen wij de website verbeteren.",
      },
      functional: {
        title: 'Functionele cookies',
        description:
          "Deze cookies zijn noodzakelijk voor het functioneren van de website. U kunt geen video's bekijken en geen adviseur zoeken.",
      },
      decline: 'Nee',
      statement: 'Cookieverklaring',
      missing: 'Je cookies moeten ingeschakeld zijn om deze video te bekijken.',
    },
    searchResults: {
      title: 'Jouw zoekopdracht',
      noSearchTerm: 'Je hebt geen zoekterm opgegeven',
      types: {
        page: 'Pagina',
        news: 'Nieuws',
        story: 'Verhaal',
      },
      noResults: 'Geen resultaten gevonden. Probeer het opnieuw met deze tips:',
      noResultsTips: {
        spelling: 'Controleer je spelling',
        describe: 'Beschrijf je zoekopdracht anders',
        shorter: 'Maak je zoekopdracht kleiner',
      },
    },
    filter: {
      noResults:
        'Geen resulten gevonden voor deze categoriey. Kies een andere category of klik <a href="/nl/nieuws/">hier</a> al het nieuws te bekijken.',
    },
    pagination: {
      previous: 'Vorige',
      next: 'Volgende',
    },
    show_button: {
      more: 'Toon meer',
      less: 'Toon minder'
    },
    share_link: {
      title: 'Delen op'
    },
    news: {
      categories: 'Categoriën:',
    },
    story: {
      categories: 'Categoriën:',
    },
    filters: {
      filter_on: 'Filter op:',
      category: 'Categorie',
      all_categories: 'Alle categorieën',
      year: 'Jaar',
      all_years: 'Alle jaren',
    },
    formMessage: 'Controleren...',
    highlights: {
      title: 'Actueel bij FrieslandCampina',
      footer_copy: 'Lees meer over de laatste ontwikkelingen bij FrieslandCampina:',
      link_copy: 'Bekijk ons nieuws',
      link_url: '/nl/nieuws/'
    },
  },
}

export default nl;
